import { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { Loader2, UserPlus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { API_BASE, withFileAuth } from '@/utils/api';

const errText = (e) => {
  const d = e.response?.data?.detail;
  return typeof d === 'string' ? d : Array.isArray(d) ? d.map(x => x.msg).join(' ') : 'No se pudo activar la cuenta';
};

export default function ActivateInvite() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [invite, setInvite] = useState(null);
  const [error, setError] = useState(null);
  const [form, setForm] = useState({ name: '', password: '' });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    axios.get(`${API_BASE}/invites/${token}`)
      .then(r => { setInvite(r.data); setForm(f => ({ ...f, name: r.data.name || '' })); })
      .catch(e => setError(errText(e)));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await axios.post(`${API_BASE}/invites/${token}/accept`, form);
      toast.success('Cuenta activada. Ya podés ingresar.');
      navigate('/login', { replace: true });
    } catch (err) {
      toast.error(errText(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-background grid place-items-center p-6">
      <div className="w-full max-w-md bg-card border border-border rounded-3xl p-8 shadow-sm" data-testid="activate-invite-page">
        {error && <p className="text-center text-red-600 font-medium" data-testid="activate-invite-error">{error}</p>}
        {!error && !invite && <Loader2 className="w-6 h-6 animate-spin mx-auto" />}
        {invite && (
          <form onSubmit={submit} className="space-y-5">
            {invite.logo_url && <img src={withFileAuth(invite.logo_url)} alt="" className="h-14 mx-auto object-contain" />}
            <div className="text-center">
              <h1 className="font-heading text-2xl font-bold">Sumate a {invite.business_name}</h1>
              <p className="text-sm text-muted-foreground mt-1" data-testid="activate-invite-role">Rol: {invite.role_name} · {invite.email}</p>
            </div>
            <div className="space-y-2">
              <Label>Tu nombre</Label>
              <Input value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} required minLength={2} data-testid="activate-name-input" />
            </div>
            <div className="space-y-2">
              <Label>Contraseña (mínimo 8, con letras y números)</Label>
              <Input type="password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} required minLength={8} data-testid="activate-password-input" />
            </div>
            <Button type="submit" className="w-full rounded-full" disabled={busy} data-testid="activate-submit-btn">
              {busy ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <UserPlus className="w-4 h-4 mr-2" />}Activar mi cuenta
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
